import { Component, OnInit } from '@angular/core';
 
import { Modelcores, Pjoint } from '../../../entity/Pjoint';
import { Observable } from 'rxjs/Observable';
import { environment } from 'src/environments/environment';
import { MailsService } from 'src/app/service/mails.service';
import { FactureService } from 'src/app/service/facture.service';
import saveAs from 'save-as'
@Component({
  selector: 'app-pjoints',
  templateUrl: './pjoints.component.html'
})
export class PjointsComponent implements OnInit {

  cols: any;
  editDialog: boolean;
  designationPjoint: string;
  uploadedFiles: any[] = [];
  modelsPjoints: Pjoint[]
  selectedModelpjointe: Pjoint;
  uploadUrl: String = environment.restApiCRM + 'mails/upload1';
  constructor(private mailsService: MailsService,private factureService:FactureService) { }
  salons: any
  salon: string
  ngOnInit() {
    this.cols = [

      { field: 'designation', header: 'Designation' }
    ];
    this.findAllPjoints();
    this.salons = [

      { label: 'HASSI MESSAOUD EXPO', value: "HME" },
      { label: 'NAPEC', value: 'NAPEC' },
    ];
  }



  findAllPjoints() {
    this.mailsService.modelPjoints().subscribe(resuls => {
      this.modelsPjoints = resuls;
    })


  }
  ajouter() {
    let pjoint = new Pjoint();
    this.editDialog = true;

    this.selectedModelpjointe = pjoint;
  }


  save() {
    let fd = new FormData();
    for (let file of this.uploadedFiles) {
      if (this.designationPjoint)

        fd.append("file", file, this.designationPjoint);
      this.designationPjoint = ""

    }
    this.mailsService.uploadModel(fd).subscribe(result => {
      this.editDialog = false;
      this.findAllPjoints();
    });
  }
  remove(pjoint: Pjoint) {
    this.mailsService.removeByPjoint(pjoint.pjointeId).subscribe(result => {
      this.findAllPjoints();
    })

  }


  openFile(pjoint: Pjoint) {
 
   this.mailsService.pjointFile(pjoint).subscribe(result => {

      saveAs(result, pjoint.fileName)

    }) 
  }

  uploadFunction(event) {

    for (let file of event.files) {

      this.designationPjoint = file.name;
      this.uploadedFiles.push(file);

    }
  }





}
